import React from 'react';
import { Link } from 'react-router-dom';
//components
import { Visibility } from 'components/Visibility';
import { Row } from 'components/Layout/Grid';
import Text from 'components/Text';
//assets
import backBtn from 'img/icon-back.svg';

interface BackButtonProps {
  onClick?: Function;
  orderDetailsPage?: boolean;
}

export const BackButton: React.FC<BackButtonProps> = ({ onClick, orderDetailsPage }) => {
  return (
    <Row className="py-1 back-button mb-3 mt-3">
      <Link
        to={orderDetailsPage ? "/pedidos-portal" : "/cotacoes-dashboard"}
        className="py-1 back-button d-flex"
        onClick={() => onClick && onClick()}
      >
        <img src={backBtn} alt="" className="mr-1" />
        <Visibility visible={!orderDetailsPage}>
          <Text size={12}>Grid de cotações/pedidos</Text>
        </Visibility>
        <Visibility visible={!!orderDetailsPage}>
          <Text size={12}>Grid de pedidos</Text>
        </Visibility>
      </Link>
    </Row>
  );
};